import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { setShowToast, setToastMessage } from "@/utils/constants/redux/sets";
import "./QuantitySelector.scss";
import { Button, Form } from "react-bootstrap";
export const QuantitySelector = ({ quantity, setQuantity, isCart = false, }) => {
    const safeQuantity = quantity || 1;
    const updateQuantity = (increase) => {
        let value;
        if (increase) {
            value = safeQuantity + 1;
        }
        else {
            value = isCart ? safeQuantity - 1 : Math.max(1, safeQuantity - 1);
        }
        setQuantity(value);
        if (isCart) {
            setShowToast(true);
            setToastMessage(`Producto ${increase ? "agregado al" : "eliminado del"} carrito`);
        }
    };
    const content = (_jsxs("div", { className: `quantity-wrapper ${isCart ? "is-cart" : ""}`, children: [_jsx(Button, { className: "qty-btn", onClick: () => updateQuantity(false), children: "\u2212" }), _jsx("span", { className: "qty-value", children: safeQuantity }), _jsx(Button, { className: "qty-btn", onClick: () => updateQuantity(true), children: "+" })] }));
    if (isCart) {
        return content;
    }
    return (_jsxs(Form.Group, { children: [_jsx(Form.Label, { children: "Cantidad" }), content] }));
};
